<template>
  <div class="mobile" :class="{ 'mobile--small': type === 'small' }">
    <!--Layout chat-->
    <template v-if="layout === 'chat'">
      <template v-if="channel === 'whatsapp'">
        <img
          v-if="type === 'default'"
          src="@/app/strategies/assets/mobile.svg"
          class="mobile__image"
        />
        <img
          v-if="type === 'small'"
          src="@/app/shared/assets/mobile-small.svg"
          class="mobile__image"
        />
      </template>
      <template v-else-if="channel === 'sms'">
        <img
          v-if="type === 'default'"
          src="@/app/strategies/assets/mobile-sms.svg"
          class="mobile__image"
        />
      </template>
      <!--Header del chat-->
      <a-row
        class="mobile__header-chat flex-no-wrap"
        :class="`mobile__header-chat--${type} mobile__header-chat--${channel}`"
        type="flex"
        align="middle"
      >
        <!--Solo se verá el avatar en el canal de whatsapp-->
        <a-avatar
          v-if="channel === 'whatsapp'"
          class="mrg-right-8 mobile__header-chat__avatar"
          :class="`mobile__header-chat__avatar--${type}`"
          :size="type === 'small' ? 24 : 32"
        >
          <img
            :src="
              require(`@/app/shared/assets/logo/light/${owner_app.toLowerCase()}-light-small.svg`)
            "
            height="20"
            width="20"
            class="mobile__header-chat__avatar__image"
          />
        </a-avatar>
        <h5 class="heading-h6 mrg-bottom-0 mobile__header-chat__title">
          {{ app }}
        </h5>
      </a-row>
      <!--Si el mensaje es un array-->
      <template v-if="Array.isArray(message)">
        <div class="mobile__container scrollbar_basic">
          <div
            v-for="(item, index) in message"
            :key="index"
            class="mobile__bubble text--left mrg-bottom-12"
            :class="{
              'mobile__default-message': !item,
              mobile__message: item,
            }"
          >
            {{ item || defaultMessage }}
          </div>
        </div>
      </template>
      <div v-else class="mobile__container scrollbar_basic">
        <div
          class="mobile__bubble text--left"
          :class="{
            'mobile__default-message': !message,
            mobile__message: message,
          }"
        >
          <!--IMAGEN-->
          <div v-if="mediaType === 'image'" class="mobile__media media-image">
            <img v-if="mediaUrl" :src="mediaUrl" class="media-image__content" />
            <i v-else class="anticon mobile__media-icon">
              <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2h16a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2zm0 2v11.586l4-4 3.5 3.5 6.5-6.5 2 2V4H4zm0 16v-1.586l4-4L13.586 20H4zm16 0h-3.586l-3.5-3.5L18 11.414l2 2V20zM14 8a3 3 0 10-6 0 3 3 0 006 0zm-4 0a1 1 0 112 0 1 1 0 01-2 0z" fill="currentColor"/></svg>
            </i>
          </div>
          <!--VIDEO-->
          <div
            v-else-if="mediaType === 'video'"
            class="mobile__media media-video"
          >
            <video v-if="mediaUrl" class="media-video__content" controls>
              <source :src="mediaUrl" type="video/mp4" />
            </video>
            <i v-else class="anticon mobile__media-icon">
              <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zM3 12a9 9 0 1018 0 9 9 0 00-18 0zm5-5a1 1 0 011.53-.848l8 5a1 1 0 010 1.696l-8 5A1 1 0 018 17V7zm2 1.804L15.113 12 10 15.196V8.804z" fill="currentColor"/></svg>
            </i>
          </div>
          <!--DOCUMENTO-->
          <div
            v-else-if="mediaType === 'document'"
            class="mobile__media media-document"
          >
            <a-icon type="file-pdf" class="mobile__media-icon--file" />
            <span class="ellipsis mrg-right-4 mrg-left-4">{{
              fileName || 'Nombre de archivo'
            }}</span>
            <i
              class="anticon mobile__media-icon--file"
              @click="mediaUrl && handleDownloadDocument(mediaUrl)"
            >
              <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm0-2a9 9 0 100-18 9 9 0 000 18zM11 7v6.586l-2.293-2.293-1.414 1.414L12 17.414l4.707-4.707-1.414-1.414L13 13.586V7h-2z" fill="currentColor"/></svg>
            </i>
          </div>
          {{ message || defaultMessage }}
        </div>
        <!--BOTONES-->
        <button-demo-wsp
          v-for="(button, index) in buttons"
          :key="index"
          :type="button.type || ''"
          :text="button.text || ''"
        />
      </div>
    </template>
    <template v-else-if="layout === 'profile'">
      <svg width="224" height="450" viewBox="0 0 224 450" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="type === 'small'" v-bind:svg-inline="''" v-bind:class="'mobile__image'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect width="224" height="450" rx="24" fill="#1F232E"/><path fill="#292F3F" d="M0 0h224v28H0z"/><path d="M18.842 18v-7.336h-.024l-2.238 1.611v-1.113l2.25-1.617h1.031V18h-1.02zm6.223.146c-.633 0-1.192-.164-1.676-.492-.485-.332-.858-.802-1.12-1.412-.277-.64-.415-1.416-.415-2.326 0-1.426.287-2.535.86-3.328.579-.793 1.386-1.19 2.42-1.19.72 0 1.333.2 1.84.598.508.399.83.93.967 1.594H26.87a1.676 1.676 0 00-.644-.914 1.821 1.821 0 00-1.102-.346c-.707 0-1.254.303-1.64.908-.387.606-.59 1.471-.61 2.596h.018a2.22 2.22 0 01.931-.996 2.79 2.79 0 011.43-.375c.805 0 1.473.266 2.004.797.535.531.803 1.197.803 1.998 0 .836-.284 1.527-.85 2.074-.563.543-1.277.814-2.145.814zm-1.383-1.5c.375.375.832.563 1.37.563.54 0 .997-.186 1.372-.557a1.84 1.84 0 00.562-1.359c0-.555-.18-1.01-.539-1.365-.36-.36-.818-.54-1.377-.54-.558 0-1.023.178-1.394.534-.367.355-.551.803-.551 1.342 0 .543.186 1.004.557 1.383zm6.82-.246a.646.646 0 01-.475.194.645.645 0 01-.474-.194.645.645 0 01-.194-.474c0-.188.065-.346.194-.475a.645.645 0 01.474-.193c.188 0 .346.064.475.193a.645.645 0 01.193.475.645.645 0 01-.193.474zm0-4.312a.646.646 0 01-.475.193.645.645 0 01-.474-.193.645.645 0 01-.194-.475c0-.187.065-.345.194-.474a.645.645 0 01.474-.194c.188 0 .346.065.475.194a.645.645 0 01.193.474.645.645 0 01-.193.475zm3.457 2.01v-.891h1.014c.484 0 .88-.139 1.19-.416a1.38 1.38 0 00.462-1.066c0-.43-.143-.772-.428-1.026-.285-.254-.69-.38-1.213-.38-.484 0-.879.128-1.183.386-.305.258-.48.61-.528 1.055H32.26c.058-.719.336-1.291.832-1.717.5-.426 1.146-.639 1.94-.639.761 0 1.394.205 1.898.616.504.41.755.931.755 1.564 0 .527-.156.97-.468 1.33-.313.36-.735.586-1.266.68v.023c.64.04 1.15.244 1.53.615.378.368.568.848.568 1.442 0 .473-.133.898-.399 1.277a2.61 2.61 0 01-1.078.88c-.453.206-.955.31-1.506.31-.875 0-1.58-.22-2.115-.657-.535-.437-.822-1.011-.861-1.722h1.013c.047.441.245.797.592 1.066.348.266.801.399 1.36.399.558 0 1.017-.143 1.377-.428.363-.285.545-.649.545-1.09 0-.496-.176-.889-.528-1.178-.347-.289-.824-.433-1.43-.433h-1.06zm8.338 4.043c-.98 0-1.746-.391-2.297-1.172-.547-.785-.82-1.852-.82-3.2 0-1.335.275-2.396.826-3.181.554-.79 1.318-1.184 2.29-1.184.974 0 1.733.393 2.28 1.178.551.781.826 1.842.826 3.182 0 1.347-.273 2.414-.82 3.199-.547.785-1.309 1.178-2.285 1.178zm-1.518-1.846c.36.617.865.926 1.518.926.652 0 1.156-.307 1.512-.92.355-.617.533-1.461.533-2.531 0-1.055-.18-1.891-.54-2.508-.359-.621-.86-.932-1.505-.932-.645 0-1.149.31-1.512.932-.363.62-.545 1.455-.545 2.502 0 1.07.18 1.914.54 2.53zm8.432-6.75h3.017c.794 0 1.442.254 1.946.762.508.503.761 1.154.761 1.95 0 .802-.253 1.456-.761 1.964s-1.16.761-1.957.761h-1.951V18H49.21V9.545zm1.055.937v3.563h1.687c.602 0 1.069-.156 1.4-.469.332-.316.499-.756.499-1.318 0-.563-.166-.998-.498-1.307-.329-.312-.795-.469-1.4-.469h-1.688zM64.48 18h-.985v-6.516h-.04l-2.696 6.457h-.89l-2.696-6.457h-.041V18h-.985V9.545h1.225l2.918 7.055h.047l2.918-7.055h1.225V18zM176.857 12.83l1.013.991c2.518-2.465 6.6-2.465 9.117 0L188 12.83c-3.074-3.01-8.063-3.01-11.143 0zm4.052 3.967l1.52 1.489 1.519-1.489a2.178 2.178 0 00-3.039 0zm-2.026-1.984l1.013.992a3.637 3.637 0 015.065 0l1.013-.992c-1.955-1.914-5.13-1.914-7.091 0zM162.608 17.429h1.928v-5.786h-1.928v5.786zm-2.893 0h1.928v-3.857h-1.928v3.857zm5.786-7.715v7.715h1.928V9.714h-1.928zM206.114 15.888v-.86h1.029v-2.056h-1.029v-.86a.687.687 0 00-.684-.683h-7.884a.688.688 0 00-.689.684v3.77c0 .38.308.689.684.689h7.889a.687.687 0 00.684-.684z" fill="#fff"/></svg>
      <div class="mobile__container mobile__container--profile scrollbar_basic">
        <!--Primera seccion-->
        <div class="text--center mobile__row">
          <div class="mobile__main-data">
            <div class="mobile__avatar-container mrg-bottom-8">
              <img
                :src="profile.avatar"
                height="48px"
                width="48px"
                alt="Avatar"
                class="mobile__avatar"
              />
            </div>
            <h6 class="semibold-14 mobile__name mrg-bottom-0">
              {{ profile.name }}
            </h6>
          </div>
          <a-divider class="mobile__divider" />
          <a-row
            type="flex"
            align="middle"
            justify="space-between"
            class="general-padding"
          >
            <p class="regular-12 mrg-bottom-0 gray-light-500">
              Esta es una cuenta de empresa
            </p>
            <a-icon type="info-circle" class="link-whatsapp" />
          </a-row>
        </div>
        <!--Segunda seccion-->
        <div class="mobile__row text--left general-padding regular-12">
          <p class="regular-12 mrg-bottom-8">
            {{ profile.description }}
          </p>
          <p class="link-whatsapp mrg-bottom-4">
            {{ profile.address }},
            {{ profile.city }}
          </p>
          <p class="link-whatsapp mrg-bottom-12">
            {{ profile.zipcode }}
            <br />
            {{ profile.country }}
          </p>
          <p class="link-whatsapp mrg-bottom-4">
            {{ profile.email }}
          </p>
          <p class="link-whatsapp mrg-bottom-0">
            {{ profile.website }}
          </p>
        </div>
        <!--Tercera seccion-->
        <div class="mobile__row general-padding">
          <h6 class="semibold-12 mrg-bottom-8 gray-light-500">
            Info. y número de teléfono
          </h6>
          <p class="regular-14">{{ profile.about }}</p>
          <span class="regular-12 gray-light-500">{{
            profile.approvedAt
          }}</span>
          <a-divider class="mobile__divider" />
          <p class="regular-14 mobile__number">{{ profile.name }}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ButtonDemoWsp from '@/app/strategies/components/atoms/ButtonDemoWsp.vue'

export default {
  name: 'MobileWsp',
  props: {
    // mensaje customizado
    message: {
      type: [String, Array],
      required: false,
      default: null,
    },
    // mensaje por defecto
    defaultMessage: {
      type: String,
      required: false,
      default:
        'Selecciona una plantilla, para previsualizar el contenido de una plantilla.',
    },
    type: {
      type: String,
      required: false,
      default: 'default',
      enum: ['default', 'small'],
    },
    layout: {
      type: String,
      required: false,
      default: 'chat',
      enum: ['chat', 'profile'],
    },
    dataSourceProfile: {
      type: Object,
      required: false,
    },
    mediaType: {
      type: String,
      required: false,
      enum: ['image', 'video', 'document'],
    },
    mediaUrl: {
      type: String,
      required: false,
    },
    fileName: {
      type: String,
      required: false,
      default: 'Nombre de archivo',
    },
    channel: {
      type: String,
      required: false,
      default: 'whatsapp',
    },
    buttons: {
      type: Array,
      required: false,
    },
  },
  components: {
    ButtonDemoWsp,
  },
  data: () => ({
    app: process.env.VUE_APP_NAME,
    owner_app: !process.env.VUE_APP_OWNER_APP
      ? process.env.VUE_APP_NAME
      : process.env.VUE_APP_OWNER_APP,
  }),
  computed: {
    profile() {
      const profile = {}
      for (let property in this.dataSourceProfile) {
        profile[property] =
          this.dataSourceProfile[property] &&
          this.dataSourceProfile[property].length > 0
            ? this.dataSourceProfile[property]
            : '...'
      }
      return profile
    },
  },
  methods: {
    /**
     * Descarga el documento de la previsualizacion
     * @param {String} url URL a descargar
     */
    handleDownloadDocument(url) {
      window.open(url)
    },
  },
}
</script>

<style lang="sass" scoped>
$background_profile: #1A1E27
$link_whatsapp: #02A386
$background_media: #272E3E
$background_whatsapp: #008069
$background_sms: #3C455E

.general-padding
  padding: 8px 12px
.link-whatsapp
  color: $link_whatsapp
.gray-light-500
  color: $gray_light_500

.mobile
  position: relative
  min-width: 200px
  &__image
    border-radius: 40px
    box-shadow: 10px 10px 50px rgba(24, 48, 63, 0.5);
  &__header-chat
    position: absolute
    color: $white_000
    &__title
      color: $white_000
    &__avatar
      object-fit: contain
      background-color: black
      &--default
        height: 20px
        width: 20px
      &--small
        height: 16px
        width: 16px
      &__image
        margin-top: -4px
    &--small
      top: 36px
      left: 24px
    &--default
      top: 40px
      left: 30px
    &--whatsapp
      background-color: $background_whatsapp
    &--sms
      background-color: $background_sms
      left: 110px
      top: 46px
  &__container
    position: absolute
    top: 80px
    left: 0px
    padding: 14px 12px
    width: 100%
    overflow-y: auto
    height: 31em
    margin-top: 2px
    &--profile
      color: $gray_2
      top: 28px!important
      padding: 0px!important
      height: 28em!important
  &__name
    color: $gray_2
  &__divider
    margin: 0px
    background-color: $gray_light_900
  &__row
    background-color: $background_profile
    margin-bottom: 12px
    &:last-child
      margin-bottom: 0px
  &__main-data
    padding: 12px
  &__number
    margin: 12px 0px
  &__mobile__avatar-container
    height: 64px
    width: 64px
    background-color: $gray_9
  &__bubble
    border-radius: 20px
    background-color: #373E4E
    max-width: 240px
    color: $gray_1
    padding: 12px
    white-space: pre-line
    overflow-wrap: break-word
  &__default-message
    color: $gray_7
  &--small
    width: fit-content
    .mobile
      &__image
        border-radius: 24px
      &__container
        top: 64px
        height: 24em
  &__media
    background-color: $background_media
    border-radius: 10px
    height: 94px
    width: 100%
    margin-bottom: 10px
    @include flex(row, center, center)
    &-icon
      font-size: 48px
      color: $gray_8
      &--file
        font-size: 20px
        color: $gray_8
  .media-document
    height: 36px
    padding: 6px
    justify-content: space-between
  .media-image__content, .media-video__content
    height: 100%
    width: 100%
    object-fit: cover
</style>
